import { Component, OnInit, ViewChild } from '@angular/core';
import { Platform, MenuController, NavController, NavParams } from 'ionic-angular';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';

import { AuthService } from '../../app/shared/services/auth.service';
import { ObservationsService } from '../../app/shared/services/observations.service';

import { HomepageComponent } from '../home/home';

import { API } from '../../app/config';

@Component({
    selector: 'page-suivi-observation',
    templateUrl: './suivi-observation.html'
})
export class SuiviObservationComponent implements OnInit {
    @ViewChild('cout') cout;
    @ViewChild('temps') temps;
    observation: any = {
        id: 0,
        rapportId: 0,
        rapportNum: '',
        dateTraitement: null,
        date: '',
        suivi: null,
        isTraite: false,
        cout: null,
        state: null,
        temps: null,
        auteur: null,
        pathImage: '',
        listPhoto: [],
        listPhotoASupprimer: []
    }
    suivi: any = {
        rapportId: 0,
        observationId: 0
    };
    loader: boolean = true;
    isReadonly: boolean = false;

    constructor(
    public api: API, 
     private platform: Platform,
     private ga: GoogleAnalytics,
     private navCtrl: NavController,
     private menuCtrl: MenuController,
     private navParams: NavParams,
     private camera: Camera,
     private observationsService: ObservationsService,
     private authService: AuthService
    ) {
        this.platform.ready().then(_ => {
            this.ga.trackView('Suivi observations');
        });
    }

    ngOnInit() {
        this.init();
    }

    async init(): Promise<any> {
        this.suivi = this.navParams.get('details') || { rapportId: 0, observationId: 0 };
        const token = await this.authService.getToken();
        if (token.statut === 'collaborateur') {
            this.isReadonly = true;
        }
        this.observationsService.getRapportObservation(this.suivi.rapportId, this.suivi.observationId).subscribe( (data: any) => {
            if (data.auteur === null) {
                this.observation.auteur = token.user;
                const dateNow = new Date();
                const month = (dateNow.getMonth() + 1 < 10) ? '0' + (dateNow.getMonth() + 1) : dateNow.getMonth() + 1;
                const day = (dateNow.getDate() < 10) ? '0' + dateNow.getDate() : dateNow.getDate();
                this.observation.date = dateNow.getFullYear() + '-' + month + '-' + day;
            } else {
                this.observation = data;
                this.observation.state = data.isTraite ? '1' : '0';
                const dateNow = new Date(data.dateTraitement);
                const month = (dateNow.getMonth() + 1 < 10) ? '0' + (dateNow.getMonth() + 1) : dateNow.getMonth() + 1;
                const day = (dateNow.getDate() < 10) ? '0' + dateNow.getDate() : dateNow.getDate();
                this.observation.date = dateNow.getFullYear() + '-' + month + '-' + day;
            }
            if (token.statut === 'collaborateur') {
                this.observation.suivi = data.suivi.replace(new RegExp('\r?\n','g'), '<br>');
            }
            this.loader = false;
        }, async (error: any) => {
            console.error(error);
            if (this.authService.refreshCalled) {
                this.authService.refreshCalled = false;
                this.navCtrl.setRoot(HomepageComponent);
            } else if (error.status === 401) {
                this.authService.refreshCalled = true;
                const refreshToken = await this.authService.getRefreshToken();
                if (refreshToken === null) {
                    await this.authService.removeToken();
                    await this.authService.removeRefreshToken();
                    this.menuCtrl.enable(true, 'unauthenticated');
                    this.menuCtrl.enable(false, 'authenticated');
                    this.navCtrl.setRoot(HomepageComponent);
                } else {
                    this.authService.refresh(refreshToken).subscribe(async (data: any) => {
                        const token = await this.authService.getToken()
                        await this.authService.setToken(token.user, data.access_token, data.statut);
                        await this.authService.setRefreshToken(data.refresh_token)
                        this.navCtrl.setRoot(SuiviObservationComponent, { details: this.suivi });
                    });
                }
            }
        });
    }

    onKeyPress(e: any): any {
        if(e.keyCode === 13) {
            this.cout._elementRef.nativeElement.children[0].blur();
            this.temps._elementRef.nativeElement.children[0].blur();
        }
    }

    takePicture(e: any): any {
        if (e.target.className === 'input-wrapper') {
            const options: CameraOptions = {
                quality: 75,
                destinationType: this.camera.DestinationType.DATA_URL,
                encodingType: this.camera.EncodingType.JPEG,
                mediaType: this.camera.MediaType.PICTURE,
                sourceType: this.camera.PictureSourceType.CAMERA,
                correctOrientation: true,
                targetWidth: 640,
                targetHeight: 480
            };
            this.camera.getPicture(options).then((imageData: any) => {
                const base64Image = imageData.replace(' ', '+');
                const photo = {
                    observationId: this.suivi.observationId,
                    imgToBase64: base64Image
                };
                this.observation.listPhoto.push(photo);
            }, (error: any) => {
                console.error(error);
            });
        }
    }

    removePicture(photo: any, item: any): any {
        if (photo.id === undefined) {
            this.observation.listPhoto.splice(item, 1);
        } else {
            this.observation.listPhotoASupprimer.push(photo);
            this.observation.listPhoto.splice(item, 1);
        }
    }

    submitForm(): any {
        this.observation.id = this.suivi.observationId;
        this.observation.isTraite = (this.observation.state === '0') ? false : true;
        this.observation.dateTraitement = this.observation.date;
        this.observation.rapportId = this.suivi.rapportId;
        const observation = Object.assign({}, this.observation);
        observation.cout = Number(observation.cout);
        observation.temps = Number(observation.temps);
        delete observation.state;
        delete observation.date;
        this.observationsService.setRapportObservation(observation).subscribe( (data: any) => {
            this.navCtrl.pop();
        });
    }

    goBack(): any {
        this.navCtrl.pop();
    }
}


// WEBPACK FOOTER //
// ./src/pages/suivi-observation/suivi-observation.ts